var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.5C10.8653 0.5 14 3.63469 14 7.5C14 11.3653 10.8653 14.5 7 14.5C3.13469 14.5 0 11.3653 0 7.5C0 3.63469 3.13469 0.5 7 0.5ZM5.54636 9.77365L3.83259 8.05846C3.54062 7.76632 3.54056 7.28992 3.83259 6.99784C4.12468 6.70582 4.6032 6.70764 4.89316 6.99784L6.10136 8.20699L9.10695 5.2014C9.39904 4.90931 9.87549 4.90931 10.1675 5.2014C10.4596 5.49342 10.4592 5.97029 10.1675 6.26196L6.63078 9.7987C6.33912 10.0904 5.86224 10.0908 5.57022 9.7987C5.56201 9.79049 5.55409 9.78216 5.54636 9.77365Z",
    fill: "#009161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenIcon2);
export default __webpack_public_path__ + "static/media/green-icon-2.ac5aa946fd7dd81e31640e914e6e60de.svg";
export { ForwardRef as ReactComponent };